import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-roboto';
import App from './components/App';
import { LoadingProvider } from './contexts/LoadingContext';
import { SnackbarProvider } from './contexts/SnackbarContext';


ReactDOM.render(
  <LoadingProvider>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </LoadingProvider>,
  document.getElementById('root')
);
